import { useQuery } from "@tanstack/react-query";
import { Link, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Icon } from "@/components/Icon";
import { Later } from "@/components/Later";
import { Failure, NotFound } from "@/features/shell/Problem";
import { ShipmentBody, ShipmentHead } from "@/features/shipments/ShipmentDetail";
import { DetailSkeleton, isNotFound } from "@/features/shipments/ShipmentPanel";
import { shipmentQuery } from "@/lib/shipments";

// One consignment as its own page (handoff §4.2): the same as the panel, for a link in a mail, a screen narrower
// than 1100 px and the phone (H-z12 … H-z14). Another company's number gives the page that is not there (H-g03).

export const Route = createFileRoute("/_portal/shipments_/$number")({
  component: ShipmentPage,
});

function ShipmentPage() {
  const { t } = useTranslation();
  const { number } = Route.useParams();
  const query = useQuery(shipmentQuery(number));

  return (
    <div className="wl-portal-page" data-screen-label="Portaal Zending">
      {!query.isError && (
        <div>
          <Link to="/shipments" className="wl-btn wl-btn--link">
            <Icon name="arrowLeft" />
            {t("nav.shipments")}
          </Link>
        </div>
      )}
      {query.isError ? (
        isNotFound(query.error) ? (
          <NotFound />
        ) : (
          <Failure error={query.error} onRetry={() => void query.refetch()} />
        )
      ) : (
        <article className="wl-side-panel wl-side-panel--page" aria-label={t("shipment.eyebrow")}>
          <div className="wl-side-panel__head">
            {query.data ? (
              <ShipmentHead shipment={query.data} />
            ) : (
              <>
                <span className="t-eyebrow">{t("shipment.eyebrow")}</span>
                <span className="wl-side-panel__title t-mono">{number}</span>
              </>
            )}
          </div>
          <div className="wl-side-panel__body">
            {query.data ? (
              <ShipmentBody shipment={query.data} />
            ) : (
              <Later>
                <DetailSkeleton />
              </Later>
            )}
          </div>
        </article>
      )}
    </div>
  );
}
